import RatingContainer from "../../components/bonusUi/rating";

const Rating = () => {
  return <RatingContainer />;
};

export default Rating;
